module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAASCAYAAACw50UTAAAAeUlEQVQ4T2N8/PixKgsLixoDdcF9SUnJa4zPnz+vY2BgaKSm2f///58kJSWVz/jixYtwBgaGKGoazsDAsFlCQmIOI5UNRTFu1HCsoUvbYHn+/HkttZMiIyPjJAkJiQJQOqed4aNJEVsI0Da10DTMaVpw0bTIpWVlAQBi0S4T6cF/dAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/image_menu.jpg
// module id = muDq
// module chunks = 13